import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import Grid from "@mui/material/Grid2";
import TextInput from "./../textInput/index";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const ratioStatusColor = (status) => {
  if (status === "Active")
    return {
      bgColor: "customColor.blueRomance",
      color: "customColor.malachite",
    };
  if (status === "Not Applied")
    return {
      bgColor: "customColor.palePink",
      color: "customColor.darkRed",
    };
};

let paramsData = {};

const EditVendorRatiosDialog = forwardRef(({ handleUpdate }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogContent>
        <Typography
          fontSize={"1.375rem"}
          fontWeight={600}
          textAlign={"center"}
          color={"primary.light"}
        >
          {paramsData?.type === "commission"
            ? " Edit Commission Ratio"
            : "Edit Sponsorship Ratio"}
        </Typography>

        <Stack
          mt={4}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography fontSize={"1.125rem"} fontWeight={500}>
            Commission Ratio: 05%
          </Typography>
          <Chip
            label={"Active"}
            sx={{
              borderRadius: "8px",
              color: ratioStatusColor("Active")?.color,
              backgroundColor: ratioStatusColor("Active")?.bgColor,
            }}
          />
        </Stack>

        <Grid container rowSpacing={2} mt={3}>
          <Grid size={12}>
            <InputLabel>Commission%</InputLabel>
            <TextInput
              InputEndIcon={<img src={APP_ICONS.fileSaveIconBlue} width={22} />}
            />
          </Grid>
        </Grid>

        <Stack
          mt={3}
          gap={2}
          flexWrap={"wrap"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography fontSize={"1.125rem"} fontWeight={600}>
            Commission
          </Typography>
          <input type="checkbox" />
        </Stack>

        <Stack direction={"row"} alignItems={"center"} gap={1} mt={4}>
          <Button
            variant="custom_outlined"
            onClick={handleUpdate}
            endIcon={<img src={APP_ICONS.fileSaveIconBlue} width={22} />}
          >
            Update & Save
          </Button>
          <Button variant="suspend_button" onClick={handleClose}>
            Discard
          </Button>
        </Stack>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default EditVendorRatiosDialog;
